import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { footerStyle } from './layout.style'
import { ResponsiveBox } from './responsive-box.component'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { FacebookSvg, InstagramSvg, LinkedInSvg, YoutubeSvg } from '../icons'
import { careStore } from '~/companies/care/care.store'
import moment from 'moment'
import { useEffectOnce } from 'react-use'
import { observer } from '~/common/mobx.decorator'

export const Footer = observer(({ ...props }) => {
	const { t } = useTranslation()
	const { instagramUrl, facebookUrl, linkedInUrl, youtubeUrl, fetchCompanyInfoPublic } = careStore
	useEffectOnce(() => {
		fetchCompanyInfoPublic()
	})

	return (
		<div css={footerStyle}>
			<ResponsiveBox position="relative" height="74px" {...props}>
				<Box
					display="flex"
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					style={{ height: '100%' }}
					spacing={1}
					className="content-container"
				>
					<Typography className="text">{t('COPY_RIGHT', { currentYear: moment().year() })}</Typography>
					<Box className="social-media-icon">
						<Typography className="text">{t('CONNECT_WITH_US')}</Typography>
						{!!linkedInUrl && <LinkedInSvg style={{ cursor: 'pointer' }} onClick={() => window.open(linkedInUrl, '_blank')} />}
						{!!facebookUrl && <FacebookSvg style={{ cursor: 'pointer' }} onClick={() => window.open(facebookUrl, '_blank')} />}
						{!!instagramUrl && <InstagramSvg style={{ cursor: 'pointer' }} onClick={() => window.open(instagramUrl, '_blank')} />}
						{!!youtubeUrl && <YoutubeSvg className="ytb-icon" style={{ cursor: 'pointer' }} onClick={() => window.open(youtubeUrl, '_blank')} />}
					</Box>
				</Box>
			</ResponsiveBox>
		</div>
	)
})
